export let dataProps = {
    id: 0,
    trigger_point: null,
    subject: '',
    email_body: '',
    sms_body: '',
    whatsapp_template_name: '',
    whatsapp_broadcast_name: '',
    whatsapp_variables: null,
    sms_entity_id: '',
    sms_template_id: '',
    send_sms: true,
    send_whatsapp: true
}


// WEBPACK FOOTER //
// ./src/store/modules/communicationTemplate/properties.js